<div class="access-info">
  @if (showAccessLabel) {
    <div
      class="access-label"
      [class.access-label-sm]="size === 'small'"
      [class.access-label-md]="size === 'medium'"
      [class.access-label-lg]="size === 'large'"
    >
      {{ (accessCode ? 'STORAGE_AREA_ACCESS_CODE' : 'STORAGE_AREA_ACCESS') | lhTranslate }}
    </div>
  }
  @if (showAccessCode) {
    <lh-shared-ui-access-code [darkMode]="darkMode" [size]="size" [value]="accessCode"></lh-shared-ui-access-code>
  }
  @if (showAccessText) {
    <div class="access-text">{{ accessText | lhTranslate }}</div>
  }
</div>

<!-- pick-up-action.component.html BEGIN -->
<!-- <div class="storage-room-info" *ngIf="shop && shop.isSelfService && accessAllowed">
  <div class="divider">
    <small class="divider-text" *ngIf="shop.storageRoomAccessCode">
      {{ 'STORAGE_AREA_ACCESS_CODE' | translate }}
    </small>
    <small class="divider-text" *ngIf="!shop.storageRoomAccessCode">
      {{ 'STORAGE_AREA_ACCESS' | translate }}
    </small>
  </div>
  <div class="access-code" *ngIf="shop && shop.hasALock && !accessCode && isLoading">
    <div class="loading-text">{{ 'RETRIEVING_ACCESS_CODE' | translate }}<span class="dots"></span></div>
  </div>
  <div class="access-code" *ngIf="accessCode">
    <div class="access-code-value">
      <span [ngClass]="style" *ngFor="let char of accessCode.split('')">{{ char }}</span>
    </div>
  </div>
  <div class="access-text" *ngIf="shop.storageRoomAccessText">{{ shop.storageRoomAccessText }}</div>
</div> -->
<!-- pick-up-action.component.html END -->

<!-- validate-booking-action.component.html BEGIN -->
<!-- <div class="storage-room-info" *ngIf="shop && shop.isSelfService && accessAllowed">
  <hr />

  <div class="access-code" *ngIf="shop && shop.hasALock && !accessCode && isLoading">
    <div class="loading-text">{{ 'RETRIEVING_ACCESS_CODE' | translate }}<span class="dots"></span></div>
  </div>

  <div class="access-code" *ngIf="accessCode">
    <span [ngClass]="style" *ngFor="let char of accessCode.split('')">{{ char }}</span>
  </div>

  <div class="access-text" *ngIf="shop.storageRoomAccessText">{{ shop.storageRoomAccessText }}</div>
</div> -->
<!-- validate-booking-action.component.html END -->
